import {combineReducers} from "redux";
import {alertsReducer, IAlertsStore} from "@web2/ap-alerts";

import {applicationsListReducer, ApplicationsStore} from "../../applications/reducers/applications_list_reducer";
import {userInfoReducer, UserInfoStore} from "../../login/reducers/user_info";

export interface IAPStore {
    account: UserInfoStore;
    alerts: IAlertsStore;
    applications: ApplicationsStore;
}

export const apReducers = combineReducers({
    account: userInfoReducer,
    alerts: alertsReducer,
    applications: applicationsListReducer
});
